"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisibleOffset = exports.isVisible = exports.BottomSheetMode = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var DomUtils_1 = require("epc-web-utils/dist/DomUtils");
var Icon_1 = require("../icon/Icon");
var BottomSheetHeader_1 = __importDefault(require("./BottomSheetHeader"));
var BottomSheetDescription_1 = __importDefault(require("./BottomSheetDescription"));
var BottomSheetButtons_1 = __importDefault(require("./BottomSheetButtons"));
var ChildrenUtils_1 = require("../../common/ChildrenUtils");
var COMPONENT_VISIBLE_SELECTOR = '.fds-bottom-sheet.is-visible';
var COMPONENT_NO_SLIDE_SELECTOR = '.fds-bottom-sheet:not(.fds-bottom-sheet-slide)';
var BottomSheetDescriptionType = (react_1.default.createElement(BottomSheetDescription_1.default, null)).type;
var BottomSheetHeaderType = (react_1.default.createElement(BottomSheetHeader_1.default, null)).type;
var BottomSheetButtonsType = (react_1.default.createElement(BottomSheetButtons_1.default, null)).type;
var BottomSheetMode;
(function (BottomSheetMode) {
    BottomSheetMode["PERSISTENT"] = "persistent";
})(BottomSheetMode = exports.BottomSheetMode || (exports.BottomSheetMode = {}));
var BottomSheet = function (props) {
    var children = props.children, classes = props.classes, icon = props.icon, mode = props.mode, slide = props.slide, visible = props.visible, otherProps = __rest(props, ["children", "classes", "icon", "mode", "slide", "visible"]);
    react_1.useEffect(function () {
        var componentVisibleOnLoad = document.querySelector(COMPONENT_NO_SLIDE_SELECTOR);
        var componentInDOM = componentVisibleOnLoad ? componentVisibleOnLoad : document.querySelector(COMPONENT_VISIBLE_SELECTOR);
        var offset = componentInDOM && typeof window !== 'undefined' ?
            parseInt(window.getComputedStyle(componentInDOM).height, 10) :
            0;
        var active = visible || componentVisibleOnLoad !== null;
        DomUtils_1.triggerEvent('Ferris.Components.BottomSheet.Visibility', {
            visible: active,
            offset: offset
        });
        // we need trigger event when un-mount
        return function () {
            DomUtils_1.triggerEvent('Ferris.Components.BottomSheet.Visibility', {
                visible: false,
                offset: 0
            });
        };
    }, [visible]);
    var bottomSheetContent = ChildrenUtils_1.filterChildrenIn(children, BottomSheetHeaderType).concat(ChildrenUtils_1.filterChildrenIn(children, BottomSheetDescriptionType));
    var bottomSheetButtons = ChildrenUtils_1.filterChildrenIn(children, BottomSheetButtonsType);
    return (react_1.default.createElement("div", __assign({ className: getClassNames(mode, slide, visible, classes) }, otherProps),
        icon && (react_1.default.cloneElement(icon, { size: Icon_1.IconSize.MEDIUM })),
        react_1.default.createElement("div", { className: "fds-bottom-sheet-content" }, bottomSheetContent),
        bottomSheetButtons && bottomSheetButtons));
};
BottomSheet.defaultProps = {
    mode: BottomSheetMode.PERSISTENT
};
var getClassNames = function (mode, slide, visible, classes) {
    var _a;
    return classnames_1.default('fds-bottom-sheet', (_a = {},
        _a["fds-bottom-sheet-" + mode.trim().toLowerCase()] = mode,
        _a['fds-bottom-sheet-slide'] = slide,
        _a['is-visible'] = visible,
        _a), classes);
};
var getDOMElement = function () {
    // SSR compatibility
    if (typeof window === 'undefined') {
        return null;
    }
    else {
        var noSlide = document.querySelector(COMPONENT_VISIBLE_SELECTOR);
        return noSlide ? noSlide : document.querySelector(COMPONENT_NO_SLIDE_SELECTOR);
    }
};
/**
 * Determines if a `BottomSheet` component is currently found in the DOM, and is currently visible/active.
 *
 * This method can be useful in situations where absolute positioning is used on
 * the page and an affordance needs to be made when the `BottomSheet` is visible,
 * vs. hidden.
 */
var isVisible = function () {
    return getDOMElement() !== null;
};
exports.isVisible = isVisible;
/**
 * Get the visible offset value associated with the space that the `BottomSheet` is currently taking up, so
 * as to handle any affordances for absolutely positioned elements on the page.
 */
var getVisibleOffset = function () {
    var element = getDOMElement();
    if (element) {
        return parseInt(window.getComputedStyle(element).height, 10);
    }
    return 0;
};
exports.getVisibleOffset = getVisibleOffset;
exports.default = BottomSheet;
